import rest from "@/utils/rest";
export default {
  GetReportInitData() {
    let link = "ReportCarWash/GetUsedCodesInitData";
    return rest
      .channel(link, {
        method: "GET",
      })
      .then((response) => rest.promiseInterceptor(response));
  },

  GetReportData: (
    PolicyNumber,
    CarNumber,
    UserID,
    ServiceID,
    StartSendDate,
    EndSendDate,
    StartAppoveDate,
    EndAppoveDate,
    fordownload
  ) => {
    let params = "?";
    params += "PolicyNumber=" + (PolicyNumber ? PolicyNumber : "");
    params += "&CarNumber=" + (CarNumber ? CarNumber : "");
    params += "&UserID=" + (UserID ? UserID : "");
    params += "&ServiceID=" + (ServiceID ? ServiceID : "");
    params += "&StartSendDate=" + (StartSendDate ? StartSendDate : "");
    params += "&EndSendDate=" + (EndSendDate ? EndSendDate : "");
    params += "&StartAppoveDate=" + (StartAppoveDate ? StartAppoveDate : "");
    params += "&EndAppoveDate=" + (EndAppoveDate ? EndAppoveDate : "");
    params += "&ForDownload=" + (fordownload ? true : false);
    let link = "ReportCarWash/GetUsedCodes" + params;

    if (fordownload) {
      rest.channelFile(link, {
        method: "GET",
      });
    } else {
      return rest
        .channel(link, {
          method: "GET",
        })
        .then((response) => rest.promiseInterceptor(response));
    }
  },
};
